import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getOneConference } from "../api/CenferenceApi";
import { Link } from "react-router-dom";
import ScrollTop from "./ScrollTop";
import Route from "../components/Route";
import Content from "../components/ContentHeader";
// import { CopyToClipboard } from "react-copy-to-clipboard/src";

// img
// import URL from "../assets/img/link.png";
// import Icon1 from "../assets/img/webinar_icon1.png";
// import Icon2 from "../assets/img/webinar_icon2.png";
// import Icon3 from "../assets/img/webinar_icon3.png";
// import Icon4 from "../assets/img/webinar_icon4.png";
// import Icon5 from "../assets/img/webinar_icon5.png";
// import Logo from "../assets/img/logo_dark.png";
// import aaLogo from "../assets/img/aa_logo.png";
// import up from "../assets/img/more_up.png";
// import down from "../assets/img/more_down.png";

const ConferenceDetail = () => {
  // const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const [conference, setConference] = useState(null);

  // id를 사용하여 데이터를 가져오는 로직을 추가합니다.
  // 예: const data = fetchDataById(id);
  useEffect(() => {
    const fetchConferenceData = async () => {
      try {
        const response = await getOneConference(id); // ID를 전달하여 API 호출
        // console.log("한개검색:: ", response.link);
        setConference(response); // 받아온 데이터를 상태에 저장
      } catch (error) {
        console.error("Error fetching conference data:", error);
      }
    };

    if (id) {
      fetchConferenceData(); // ID가 있을 때 데이터 요청
    }
  }, [id]); // ID가 변경될 때마다 호출

  if (!conference) {
    return <div>Loading...</div>; // 로딩 상태 표시
  }

  return (
    <div className="webinar_wrap">
      <ScrollTop />

      <Content
        title="CONFERENCE"
        title1="콘텐츠를 통해 인사이트를 얻어보세요"
      />

      <Route route1="MEDIA" route2="CONFERENCE"></Route>

      <div className="contents_wrap content_bg">
        <h1>컨퍼런스 · 웨비나 · 세미나 아카이브</h1>
        <div className="container">
          {/* {conference.division === "ONLINE" && (
            <div className="conference_box">
              <div className="cont1">
                <h2 className="heading1">
                  2024 Automation Anywhere 생성형 AI 웨비나
                </h2>
                <h3>생성형 AI, 비즈니스를 위한 필수 도구가 되다.</h3>
                <CopyToClipboard
                  text="https://rbrain.co.kr/media/conference"
                  onCopy={() => alert("클립보드에 복사되었습니다.")}
                >
                  <button className="url_link">
                    <img src={URL} alt="이미지" />
                    링크 복사하기
                  </button>
                </CopyToClipboard>

                <div className="logo_wrap">
                  <img src={Logo} alt="이미지" />
                  <img src={aaLogo} alt="이미지" />
                </div>

                <button
                  className="toggle_btn"
                  onClick={() => setIsOpen((prev) => !prev)}
                >
                  행사 소개
                  <img
                    src={isOpen ? up : down}
                    alt={isOpen ? "더보기 닫기" : "더보기"}
                    style={{ width: "24px", height: "24px", marginTop: "10px" }}
                  />
                </button>
              </div>

              {isOpen && (
                <div className="cont2">
                  <p className="title">웨비나 소개</p>
                  <div className="iframe" style={{ marginTop: "30px" }}>
                    <iframe
                      src="https://www.youtube.com/embed/1JhkETMTuYY?si=nhm-ic2yNhTwK3Wq"
                      title="YouTube video player"
                      frameBorder="0" // 카멜 케이스로 수정
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin" // 카멜 케이스로 수정
                      allowFullScreen // 카멜 케이스로 수정
                    ></iframe>
                  </div>
                  <p className="mt_minus">
                    2022년 말에 챗GPT가 등장하면서 2023년 한 해 동안 AI 기술의
                    지형도가 크게 바뀌었다. 비즈니스 관점에서 보면, 기존의 규칙
                    기반이나 딥러닝 기반의 인공지능은 데이터를 분석해서 원인을
                    찾거나 미래를 예측하는 등 의사 결정 과정에서 통찰을 제공하기
                    위한 목적이 컸지만, 챗GPT로 대표되는 생성형 AI는 사람의
                    입력을 받아서 의도에 맞는 결과를 출력한다는 점에서 우리
                    모두에게 강한 충격을 줬다.
                    <br />
                    <br />
                    하지만 단일한 벤더 중심의 상자만 열면 바로 나오는 기성품이
                    아니라는 사실이 무척 중요하다. 상용 서비스는 물론이고 오픈
                    소스를 등에 업은 오픈 모델까지 매주 새로운 기술이 쏟아져
                    나오고, 데이터센터에서 동작하는 생성형 AI 워크로드는
                    하드웨어 발전에 따라 점차 스마트폰을 비롯한 엣지 단으로
                    내려오고 있다. 이처럼 하루가 다르게 발전하는 기술 환경에서
                    경쟁에 뒤쳐지지 않으려면 기업이 확보하고 있는 데이터와
                    컴퓨팅 자원을 최대로 활용해 기존 서비스나 제품과 연계하거나
                    신규 서비스나 제품을 만들어내야만 한다. 아날로그에서
                    디지털로 전환하는 만큼이나 중요한 변화가 한꺼번에 그것도
                    매우 빠르게 일어나고 있다.
                    <br />
                    <br />
                    기업들이 자동화를 넘어서 초지능화로 접근할 때 생성형 AI는
                    빼놓을 수 없는 핵심 기술로 자리잡고 있기에 생성형 AI를
                    둘러싼 생태계를 제대로 이해할 필요성이 생겼고, 이를 위해
                    이번 세미나에서는 2024년에 일어날 변화를 생성형 AI 관점에서
                    조감하기로 한다.
                  </p>

                  <p className="title" style={{ marginTop: "70px" }}>
                    웨비나 개요
                  </p>
                  <div className="d-flex">
                    <div className="d-column">
                      <img src={Icon1} alt="이미지" />
                      <p>
                        2024년
                        <br />
                        4월~10월까지
                        <br />
                        (월 1회)
                      </p>
                    </div>
                    <div className="d-column">
                      <img src={Icon2} alt="이미지" />
                      <p>
                        온라인
                        <br />
                        (YouTube)
                      </p>
                    </div>
                    <div className="d-column">
                      <img src={Icon3} alt="이미지" />
                      <p>
                        비즈니스 자동화가
                        <br />
                        필요한 기업 및<br />
                        기관 종사자
                      </p>
                    </div>
                    <div className="d-column">
                      <img src={Icon4} alt="이미지" />
                      <p>무료</p>
                    </div>
                    <div className="d-column">
                      <img src={Icon5} alt="이미지" />
                      <p>
                        레인보우브레인
                        <br />
                        홈페이지
                        <br />
                        (각 콘텐츠)
                      </p>
                    </div>
                  </div>
                  <p className="d-end">
                    * 발표주제 및 일정은 상황에 따라 변경될 수 있습니다.
                  </p>
                </div>
              )}
            </div>
          )} */}

          <div className="news_box">
            <div className="news_badge">
              <span>{conference.division}</span>
            </div>

            <div className="news_content">
              <img src={conference.img} alt="이미지" />

              <div className="text_box">
                <span>행사 소개</span>
                <table className="intro">
                  <thead>
                    {conference.title && (
                      <tr>
                        <th>행사명</th>
                        <td style={{ lineHeight: "26px" }}>
                          {conference.title}
                        </td>
                      </tr>
                    )}

                    {conference.content && (
                      <tr>
                        <th>주제</th>
                        <td style={{ lineHeight: "26px" }}>
                          {conference.content}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <th>일시</th>
                      <td>
                        {(() => {
                          const date = new Date(conference.published_date);
                          const options = {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            weekday: "long",
                          };
                          const formattedDate = date.toLocaleDateString(
                            "ko-KR",
                            options
                          ); // 'YYYY년 M월 D일 (요일)' 형식
                          // const timeOptions = {
                          //   hour: "numeric",
                          //   minute: "numeric",
                          //   hour12: true
                          // };
                          // const formattedTime = date.toLocaleTimeString(
                          //   "ko-KR",
                          //   timeOptions
                          // ); // '오전 08시' 형식

                          return `${formattedDate} | ${conference.event_time}`;
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <th>비용</th>
                      <td>{conference.fee}</td>
                    </tr>
                    <tr>
                      <th>장소</th>
                      <td>{conference.location}</td>
                    </tr>
                    <tr>
                      <th>채널</th>
                      <td>{conference.platform}</td>
                    </tr>
                  </thead>
                </table>

                <p style={{ paddingTop: "32px", whiteSpace: "pre-line" }}>
                  {conference.content_explain}
                </p>
              </div>
            </div>

            <a
              href={conference.link}
              target="_blank"
              rel="noopener noreferrer"
              className="btn_webinar"
            >
              {conference.valuelink === "link" ? "보러가기" : "등록하기"}
            </a>

            <div className="news_btn">
              <Link to="/media/Conference">
                <button className="btn_prev">목록</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConferenceDetail;
